import {Outlet} from "react-router-dom";
import SideBar from "@/components/common/Sidebar";
import './index.css'

const BaseLayout = () => (
 <div className="base-layout">
   <SideBar />
   <div className="w-full h-full">
     <Outlet />
   </div>
 </div>
)

export default BaseLayout;
